// extracted by mini-css-extract-plugin
module.exports = {"videoEmbedContainer":"VideoEmbed_videoEmbedContainer__I7hxB","videoEmbed":"VideoEmbed_videoEmbed__Tdaoh"};